#import "../flexibleSections/flexibleSections.graphql"
#import "~/graphql/fragments/socialFragment.graphql"

fragment teamOverviewPageContent on teamOverview_Entry {
    title
    description: richTextMinimal
    seo {
        ... socialFragment
    }
    showNewsletterSubscribe
}
